import React, { useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars-4";
import { useSnackbar } from "notistack";
import {
  CircularProgress,
  Backdrop,
  Container,
  Stack,
  Breadcrumbs,
  Toolbar,
  Typography,
  Paper,
  Link,
  // Tooltip,
} from "@mui/material";
import { getSchema } from "../helpers/schemas/getSchema";
import FeatureFields from "../Feature/FeatureFields";
import { useNavigate } from "react-router-dom";
import ViewFiles from "../Dialogs/ViewFiles";
// import IssueEdit from "../Issues/IssueEdit";
import CommentsList from "../Comments/CommentsList";
import IssuesEdit from "../Issues/IssuesEdit";
import ExportButton from "../Dialogs/ExportButton";
import IssuesLog from "./IssuesLog";
import { getUserAccess } from "../helpers/getUserAccess";
import { getProject } from "../helpers/getProject";

export default function Issue(props) {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(true);
  const [isReady, setIsReady] = React.useState(false);
  const [project, setProject] = React.useState({});
  const [issue, setIssue] = React.useState({});
  const [schema, setSchema] = React.useState([]);
  const [editingIssue, setEditingIssue] = React.useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = window.location.href.split("/");

        const proj = await getProject(params[4]);
        setSchema(getSchema("issue"));

        const pathSegments = window.location.pathname.split("/");
        const obs = proj.Issues.find((o) => o.id === pathSegments[4]);
        setIssue(obs);
        setProject(proj);
      } catch (error) {
        console.error("Error getting document:", error);
        enqueueSnackbar(error.message, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };

    if (isLoading === true && isReady === false) {
      setIsReady(true);
      fetchData();
    }
  });

  const onEditClick = () => {
    setEditingIssue(!editingIssue);
  };

  const passUpProject = (proj) => {
    setProject({
      ...proj,
    });
    setIssue({
      ...proj.Issues.find((o) => o.id === issue.id),
    });
    setEditingIssue(false);
  };

  return isLoading ? (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : (
    <Scrollbars
      autoHide
      autoHideTimeout={10}
      style={{ width: "100%", height: "100%" }}
    >
      <Toolbar />
      <Container
        maxWidth="xl"
        style={{
          // paddingTop: 30,
          paddingBottom: 30,
          // paddingBottom: theme.spacing(4),
          justifyContent: "center",
        }}
      >
        <Typography
          color="primary.light"
          style={{ paddingTop: 40 }}
          variant="h5"
          gutterBottom
        >
          {`Issue No: ${issue.No}`}
        </Typography>
        <Stack
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
          spacing={2}
        >
          <Breadcrumbs separator="›" aria-label="breadcrumb">
            <Link
              underline="hover"
              key="1"
              color="inherit"
              href=""
              onClick={() =>
                navigate(`/project/${project.id}/dashboard`, {
                  state: { passProject: project },
                })
              }
            >
              Project: {project.Name}
            </Link>
            ,
            <Link
              underline="hover"
              key="2"
              color="inherit"
              href={`/project/${project.id}/issues`}

              // onClick={handleClick}
            >
              {`Issues`}
            </Link>
            ,
            <Typography
              underline="hover"
              key="2"
              color="inherit"
              href={`/project/${project.id}/issue`}

              // onClick={handleClick}
            >
              {`Issue No: ${issue.No}`}
            </Typography>
            ,
          </Breadcrumbs>
        </Stack>

        <Stack
          // style={{ paddingTop: 10 }}
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <ExportButton
            issue={issue}
            observation={null}
            project={project}
            exportTableName="Issue"
          />
        </Stack>

        {issue.equipment_id && issue.equipment_id.length > 0 && (
          <Breadcrumbs separator="›" aria-label="breadcrumb">
            <Link
              underline="hover"
              key="1"
              color="inherit"
              href=""
              onClick={() =>
                navigate(
                  `/project/${project.id}/equipment/${project.Equipment.find((e) => e.id === issue.equipment_id)?.id}`,
                  {
                    state: { passProject: project },
                  },
                )
              }
            >
              Issue source: Equipment:{" "}
              {project.Equipment.find((e) => e.id === issue.equipment_id)?.Name}
            </Link>
          </Breadcrumbs>
        )}
        {issue.observation_id && issue.observation_id.length > 0 && (
          <Breadcrumbs separator="›" aria-label="breadcrumb">
            <Link
              underline="hover"
              key="1"
              color="inherit"
              href=""
              onClick={() =>
                navigate(
                  `/project/${project.id}/observation/${project.Observations.find((o) => o.id === issue.observation_id)?.id}`,
                  {
                    state: { passProject: project },
                  },
                )
              }
            >
              Issue source: Observation No:{" "}
              {project.Observations.find((o) => o.id === issue.observation_id)?.No}
            </Link>
          </Breadcrumbs>
        )}

        <Paper elevation={6} style={{ width: "100%", marginTop: 30 }}>
          <div style={{ padding: 16 }}>
            <FeatureFields
              allowUpdate={
                getUserAccess(props.user, project.uid, project.Contacts)
                  .allowUpdate
              }
              TableName={"Issue"}
              feature={issue}
              schema={schema}
              key={0}
              onEditClick={onEditClick}
            />
          </div>
        </Paper>
        {project.issues_log.filter((i) => i.id === issue.id).length > 0 && (
          <div>
            <Typography
              color="primary.light"
              style={{ paddingTop: 40 }}
              variant="h5"
              gutterBottom
            >
              Issue Log
            </Typography>
            <IssuesLog
              log={project.issues_log.filter((i) => i.id === issue.id)}
            />
          </div>
        )}

        <Typography
          color="primary.light"
          style={{ paddingTop: 40 }}
          variant="h5"
          gutterBottom
        >
          Issue Files
        </Typography>
        <ViewFiles
          issueId={issue.id}
          onEditClick={onEditClick}
          viewFiles={project.Files.filter((i) => i.issue_id === issue.id)}
        />

        <Typography
          color="primary.light"
          style={{ paddingTop: 40 }}
          variant="h5"
          gutterBottom
        >
          Issue Comments
        </Typography>

        {project !== null && (
          <CommentsList
            user={props.user}
            project={project}
            issueId={issue.id}
            observationId={null}
            equipmentId={null}
            passUpProject={passUpProject}
            saveCurrentProject={props.saveCurrentProject}
          />
        )}

        {editingIssue && (
          <IssuesEdit
            issue={issue}
            project={project}
            passUpProject={passUpProject}
            user={props.user}
            onEditClick={onEditClick}
          />
        )}
      </Container>
    </Scrollbars>
  );
}
